<div class="update-manager-container">
    <div class="d-flex justify-content-between">
        <div class="tabs-container elements-inline spaced">
            <button (click)="currentTab = tabAll" class="tab" [ngClass]="{'active': currentTab == tabAll}">All</button>
            <button (click)="currentTab = tabFrontend" class="tab" [ngClass]="{'active': currentTab == tabFrontend}">Frontend</button>
            <button (click)="currentTab = tabBackend" class="tab" [ngClass]="{'active': currentTab == tabBackend}">Backend</button>
        </div>
        <button (click)="checkUpdates()" class="button mini" style="align-self: end">
            <mat-icon>sync</mat-icon>
            Check for updates
        </button>
    </div>
    <div class="packages-table">
        <span class="pt-loader" *ngIf="workingFrontend || workingBackend">
            <mat-icon class="status-icon">refresh</mat-icon>
            <span>Loading more in background...</span>
        </span>
        <div *ngIf="showFrontendTab()">
            <div *ngFor="let appPackage of appPackagesFrontend" class="row-item">
                <div class="package-name">
                    <mat-icon class="status-icon">list_alt</mat-icon>
                    <span>{{appPackage.name}}</span>
                </div>
                <div class="version-data-container">
                    <div class="version-data">
                        <span class="badge-version">{{appPackage.current}}</span>
                        <span *ngIf="updateAvailable(appPackage)" class="new-version-container">
                            <mat-icon class="status-icon">arrow_right_alt</mat-icon>
                            <span class="badge-version update">{{appPackage.latest}}</span>
                        </span>
                    </div>
                    <span class="project-text-frontend">{{appPackage.project}}</span>
                </div>
            </div>
        </div>
        <div *ngIf="showBackendTab()">
            <div *ngFor="let appPackage of appPackagesBackend" class="row-item">
                <div class="package-name">
                    <mat-icon class="status-icon">list_alt</mat-icon>
                    <span>{{appPackage.name}}</span>
                </div>
                <div class="version-data-container">
                    <div class="version-data">
                        <span class="badge-version">{{appPackage.current}}</span>
                        <span *ngIf="updateAvailable(appPackage)" class="new-version-container">
                            <mat-icon class="status-icon">arrow_right_alt</mat-icon>
                            <span class="badge-version update">{{appPackage.latest}}</span>
                        </span>
                    </div>
                    <span class="project-text-backend">{{appPackage.project}}</span>
                </div>
            </div>
        </div>
    </div>
</div>